import { useMemo } from "react";
import fetch from "unfetch";
import useSWR, { ConfigInterface } from "swr";
import { parseMapresourceXML } from "../utils/parseMapresourceXML";
import { IMapresource } from "../models/Mapresource";
import { TilannekuvaCacheKeys } from "./cacheKey";

export type IUseMapresourceHook = (tilesetUrl: string, config?: ConfigInterface<any>) => {
    data: IMapresource | null;
    fetching: boolean;
}

export const useMapresource: IUseMapresourceHook = (tilesetUrl, config = {}) => {

    tilesetUrl = tilesetUrl.replace(/\s/g, "")
    const mapresourceUrl = tilesetUrl.endsWith("/{z}/{x}/{y}.png") ?
        tilesetUrl.replace("/{z}/{x}/{y}.png", "/tilemapresource.xml")
        : tilesetUrl;

    const fetcher = async (): Promise<IMapresource | null> => {

        const response = await fetch(mapresourceUrl);

        if (!response.ok) {
            throw Error("Failed to fetch tilemapresource")
        }

        const textData = await response.text();

        const data = parseMapresourceXML(textData);

        return data;
    };


    const cacheKey = TilannekuvaCacheKeys.MapresourceInstance(tilesetUrl);

    const { data, isValidating } = useSWR(
        cacheKey,
        fetcher,
        { suspense: true, ...config }
    );


    const rawData = data ?? null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating
    }), [rawData, isValidating]);
};
